import { api } from '../middlewares';

const indiqueGanhe = async (dadosPessoaIndicada) => {
  try {
    await api.put('Destaque/IndiqueGanhe', dadosPessoaIndicada);
    return true;
  } catch (error) {
    return false;
  }
};

export { indiqueGanhe };
